import PageTabs from '@/components/page/PageTabs';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import { query } from '@/redux/selectors/querySelectors';
import OutputViewerSection from '../OutputViewerSection';
import { action } from '@/lib/api.js';
import { workflowStepTabMemory } from '@/screens/workflows/redux/selectors/workflowScreenSelectors.js';

const labels = {
  data: 'Sent Payload',
  originalData: 'Original Payload',
  args: 'Original Body'
};

const PayloadSection = ({ request, stepId }) => {
  const { arguments: args, data, originalData } = request;

  const tabData = [
    { key: 'data', value: data },
    { key: 'originalData', value: originalData },
    { key: 'args', value: args?.body }
  ].filter((n) => !!n.value);

  const defaultTab = tabData[0]?.key || 'data';
  const memoryTab = useArgSelector(workflowStepTabMemory, { stepId, tabKey: 'payloadSectionTab' });
  const queryTab = useArgSelector(query, 'payloadSectionTab');
  const activeTab = (stepId ? memoryTab : queryTab) || defaultTab;

  const handleTabChange = (value) => {
    if (stepId) {
      action('SET_WORKFLOW_STEP_TAB_MEMORY', { stepId, tabKey: 'payloadSectionTab', value });
    }
  };

  const childrenMap = {};
  const items = [];

  tabData.forEach((n) => {
    childrenMap[n.key] = <OutputViewerSection.CodeBlock code={n.value} />;
    items.push({ value: n.key, label: labels[n.key] });
  });

  if (!data && !originalData && !args) {
    return (
      <OutputViewerSection className={'py-2'}>
        <OutputViewerSection.CodeBlock code={request} />
      </OutputViewerSection>
    );
  }

  return (
    <OutputViewerSection className={'py-2'}>
      <PageTabs items={items} tabKey={'payloadSectionTab'} activeTab={stepId ? activeTab : undefined} defaultTab={defaultTab} onChange={handleTabChange} />
      <div className="content">{activeTab !== undefined && childrenMap[activeTab]}</div>
    </OutputViewerSection>
  );
};

export default PayloadSection;
